module.exports = __webpack_public_path__ + "img/red_005.3ae63e4b.png";